import React from 'react';
import { Layout } from 'react-admin';
import MyAppbar from './MyAppbar';
// import MyMenu from './MyMenu';
import MyMenu from './Menu';

export const MyLayout = props => <Layout {...props} appBar={MyAppbar} menu={MyMenu}  />;

// export default MyLayout;
